export const menuWidth = 85;
export const triggerWidth = 38;
